import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type IconButtonVariant = 'default' | 'ghost' | 'danger';
export type IconButtonSize = 'sm' | 'md' | 'lg';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-icon-button',
  styleUrl: './icon-button.scss',
  templateUrl: './icon-button.html',
})
export class IconButtonComponent {
  /** Libellé accessible (obligatoire pour l'accessibilité). */
  readonly label = input.required<string>();

  /** Variante visuelle. */
  readonly variant = input<IconButtonVariant>('default');

  /** Taille du bouton. */
  readonly size = input<IconButtonSize>('md');

  /** Désactive le bouton. */
  readonly disabled = input(false);

  protected get cssClass(): string {
    return [
      'ui-icon-button',
      `ui-icon-button--${this.variant()}`,
      `ui-icon-button--${this.size()}`,
    ].join(' ');
  }
}
